"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAsyncHandlers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _actionHelpers = require("./actionHelpers");

var _asyncHelpers = require("./asyncHelpers");

var _effects = require("redux-saga/effects");

var _withSagas = require("./withSagas");

var handlerTakers = {
  successHandler: _actionHelpers.toSuccess,
  errorHandler: _actionHelpers.toError,
  pendingHandler: _actionHelpers.toRequest
};
var handlerProps = (0, _ramda.keys)(handlerTakers);

var getHandlerPattern = function getHandlerPattern(asyncAction, actionType, getProps) {
  return function (takedAction) {
    if (takedAction.type === actionType) {
      var props = getProps();
      return (0, _ramda.equals)((0, _asyncHelpers.callWithProps)(asyncAction.params, props), takedAction.requestAction.params);
    }

    return false;
  };
};

var withAsyncHandlers = function withAsyncHandlers(actionsConfig) {
  return function (WrappedComponent) {
    return (
      /*#__PURE__*/
      function (_Component) {
        (0, _inherits2["default"])(_class, _Component);

        function _class(props) {
          var _this;

          (0, _classCallCheck2["default"])(this, _class);
          _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_class).call(this, props));
          var actions = (0, _asyncHelpers.getActions)(props, actionsConfig);
          var sagas = [];
          (0, _ramda.forEachObjIndexed)(function (action, actionName) {
            (0, _ramda.when)((0, _ramda.prop)('saga'), function (action) {
              sagas.push(action.saga);
            }, action);
            var actionHandlers = (0, _ramda.pick)(handlerProps, action);
            (0, _ramda.forEachObjIndexed)(function (handler, key) {
              var actionType = (0, _ramda.pathOr)(action.type, [actionName, 'type'], props);
              var actionHandlerType = actionType && handlerTakers[key] && handlerTakers[key](actionType);

              if (handler && actionHandlerType) {
                sagas.push(
                /*#__PURE__*/
                _regenerator["default"].mark(function _callee2(getProps) {
                  var pattern;
                  return _regenerator["default"].wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          pattern = getHandlerPattern(action, actionHandlerType, getProps);
                          _context2.next = 3;
                          return (0, _effects.takeEvery)(pattern,
                          /*#__PURE__*/
                          _regenerator["default"].mark(function _callee(takedAction) {
                            return _regenerator["default"].wrap(function _callee$(_context) {
                              while (1) {
                                switch (_context.prev = _context.next) {
                                  case 0:
                                    _context.next = 2;
                                    return handler(getProps(), takedAction);

                                  case 2:
                                  case "end":
                                    return _context.stop();
                                }
                              }
                            }, _callee);
                          }));

                        case 3:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));
              }
            }, actionHandlers);
          }, actions);

          if (sagas.length) {
            _this.Component = (0, _withSagas.withSagas)(sagas)(WrappedComponent);
          } else {
            _this.Component = WrappedComponent;
          }

          return _this;
        }

        (0, _createClass2["default"])(_class, [{
          key: "render",
          value: function render() {
            return _react["default"].createElement(this.Component, this.props);
          }
        }]);
        return _class;
      }(_react.Component)
    );
  };
};

exports.withAsyncHandlers = withAsyncHandlers;